<template>
  <div class="usage-detail">
    <div class="header"><span class="span_title">利用明細</span></div>
    <template v-if="isLoading">
      <AppLoading />
    </template>
    <template v-else>
      <div class="wrap-usage-detail">
        <div class="wrap-set-date">
          <button class="cs-btn-back-date" @click="onChangeMonth('prev')">
            <img class="pr-1 mt2" src="@/assets/images/arrow-left.svg" /><span>前月</span>
          </button>
          <div>
            <a-month-picker
              @change="onSelectMonth"
              format="YYYY年MM月分"
              :value="monthSelected"
              :allowClear="false"
              :showToday="false"
              :inputReadOnly="true"
            >
              <template #suffixIcon>
                <img src="@/assets/images/arrow-down-thin.svg" />
              </template>
            </a-month-picker>
          </div>
          <button class="cs-btn-back-date" @click="onChangeMonth('next')">
            <span class="pr-1">次月</span
            ><img
              class="mt2"
              src="@/assets/images/arrow-right-strong-gray.svg"
              height="11"
              width="6.28"
            />
          </button>
        </div>
        <div class="wrap-amount-payment">
          <div class="row wrap-amount-payment__div mx-0 font-weight-bold align-items-center">
            <div class="row mx-0 pl-0 pr-2 align-items-center">
              <div class="title-payment px-0">お支払い金額</div>
              <div class="row">
                <div
                  class="wrap-money-payment d-flex align-items-center"
                >
                  <div v-if="status === isStatus" class="tag-payment">未確定</div>
                  <div v-else class="tag-not-payment">確定</div>
                  <div class="money-payment">{{ price }}</div>
                </div>
              </div>
            </div>
            <div class="mx-0 px-0 justify-content-end pc-time">
              <div class="d-flex mx-0 pl-0 align-items-center">
                <div class="title-payment1 px-0">お支払い日</div>
              </div>
              <div>
                <div class="px-0 text-month">{{nextMonth}} ({{dayOfWeek}})</div>
                <div class="mx-0">
                  <div class="px-0 text-right mgt-10 description-text w3">土日祝日の場合は前営業日</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-0 px-0 mobile-time">
            <div class="d-flex mx-0 pl-0 align-items-center">
                <div class="title-payment1 px-0">お支払い日</div>
            </div>
            <div>
              <div class="px-0 text-month w6">{{nextMonth}} ({{dayOfWeek}})</div>
              <div class="mx-0">
                <div class="px-0 text-right mgt-10 description-text">土日祝日の場合は前営業日</div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="wrap-withdrawal">
            <div class="row mx-0 align-items-center">
              <div class="mr-3 title-payment font-weight-bold">請求先変更</div>
              <button class="change-withdrawal-account text-bold" @click="onChangeRouter()">変更</button>
            </div>
            <div>
              <span>請求書は、マネーフォワードケッサイ株式会社が運営する</span><br />
              <span
                >請求代行サービス「マネーフォワード ケッサイ」よりご請求させていただきます。</span
              >
            </div>
            <div class="banner">
              <a href="https://mfkessai.co.jp/kessai/buyer" target="_blank"><img class="image_banner" src="https://c.mfkessai.co.jp/img/material/ec/bnr01_468_60.png" /></a>
            </div>
            <div class="row mx-0 align-items-center tooltip-div">
              <div class="mr-3 note-withdrawal">ご注意</div>
              <a-tooltip
                placement="top"
                arrow-point-at-center
              >
                <img src="@/assets/images/ic_question.svg" />
                <template #title>
                  <div class="div-tooltip">
                    <span>ご請求方法</span><br>
                    <span>- 請求書は、マネーフォワードケッサイ株式会社よりメール送信されます。</span><br>
                    <span>- 締め月の翌月初5営業日以内にメールにて請求書をお送りします。</span><br>
                    <br>
                    <span>お支払い方法（銀行振込）</span><br>
                    <span>- お支払先口座　：　請求書に記載（マネーフォワードケッサイ株式会社の銀行口座になります。）</span><br>
                    <span>- 銀行振込手数料：　貴社でのご負担をお願いいたします。</span><br>
                    <span>- お支払期日　　：　原則、月末締め翌月末支払いとします</span><br>
                    <br>
                    <span>お支払方法（口座振替）</span><br>
                    <span>- 振替元口座　　：　貴社申請登録の指定口座になります。</span><br>
                    <span>- 振替先口座　　：　マネーフォワードケッサイ株式会社の銀行口座になります。</span><br>
                    <span>- 口座振替手数料：　無料（マネーフォワードケッサイ株式会社が負担いたします。）</span><br>
                    <br>
                    <span>※新規に口座振替のご利用を希望される場合は、弊社までお問合せ頂くか、</span><br>
                    <span>  請求書受領後にマネーフォワード ケッサイ インボックス（<a href="https://b.mfk.jp/get-start" target="_blank">https://b.mfk.jp/get-start</a>）よりお申込みください。</span><br>
                    <span>  マネーフォワード ケッサイ インボックスには請求書送付先のメールアドレスにてログインできます。</span><br>
                    <br>
                    <span>その他</span><br>
                    <span>- マネーフォワード ケッサイはマネーフォワードケッサイ株式会社が運営しております。</span><br>
                    <span>- 当サービスではマネーフォワードケッサイ株式会社が、請求業務の受託及び代金債権の収受権限の付与を受け、又は、販売元から当該債権の債権譲渡を受けて、請求書の発行や代金の回収、管理を行っております。</span><br>
                    <span>- 審査の結果、別のお支払方法をご提案する可能性がございます。予めご了承ください。</span><br>
                    <span>- 請求書の発行元およびご入金先口座名義は、マネーフォワードケッサイ株式会社となります。お間違えのないようご注意ください。</span><br>
                    <span>- 領収書の発行をご希望の場合、以下のお問い合わせフォームよりお問合せください。</span><br>
                    <span><a href="https://inquiry.mfkessai.co.jp/form" target="_blank">https://inquiry.mfkessai.co.jp/form</a></span><br>
                    <span>※発行までに、1週間ほどお時間をいただく場合がございます。</span><br>
                    <span>※領収書の発行は、ご入金単位毎にお問い合わせいただく必要がございます。</span><br>
                    <span>- その他、よくあるご質問やお問い合わせにつきましては下記をご参照ください。</span><br>
                    <span><a href="https://inquiry.mfkessai.co.jp/" target="_blank">https://inquiry.mfkessai.co.jp/</a></span><br>
                    <span>※ ご請求の内容（お宛名、明細、金額を含む）に関するお問い合わせにつきましては、弊社宛てにご連絡ください。</span>
                  </div>
                </template>
              </a-tooltip>
            </div>
          </div>
        </div>
        <div class="wrap-detail-payment">
          <div class="header-detail-payment row mx-0 justify-content-between">
            <div class="font-weight-bold title-detail">明細</div>
            <div class="export-file-payment">
              <button @click="handleExportPDF()" class="export-btn btn-pdf mr-10">
                <img src="@/assets/images/document-pdf-gray.svg" /><span class="pl-3"
                  >明細印刷用PDF</span
                >
              </button>
              <button @click="handleExportCSV()" class="export-btn">
                <img src="@/assets/images/page-export-csv.svg" /><span class="pl-3"
                  >明細コピー用Excel (CSV)</span
                >
              </button>
            </div>
          </div>
          <div class="content">
            <div class="wrap-month-title font-weight-bold">
              <div class="col-md-6 px-0"><span>{{ monthNow }}月お支払い予定金額の明細</span></div>
              <div class="col-md-6 px-0 day-month">{{dayOfMonth}}  ご利用分</div>
            </div>
            <div class="d-flex">
              <div class="d-flex per_page_top">
                <div class="text-per-page"><span class="mr-2">件数</span></div>
                <div>
                  <a-select
                    ref="select"
                    v-model:value="perPage"
                    :options="PER_PAGE_OPTIONS"
                    class="per_page"
                    @focus="focus"
                    @change="handleChangePerPage"
                  >
                    <template #suffixIcon>
                      <img src="@/assets/images/select_icon.svg" />
                    </template>
                  </a-select>
                </div>
              </div>
              <div class="w-100">
                <Pagination
                  @currentPage="changePage" showPageBottom="true"
                  :total="this.usageDetail?.total"
                  :pageSize="this.usageDetail?.per_page"
                  :page="this.usageDetail?.page"
                  ref="paginationRef1"
                />
              </div>
            </div>
            <a-table
              :columns="columns"
              :data-source="data"
              :expandIconColumnIndex="4"
              :pagination="false"
              v-model:expanded-row-keys="expandColumns"
              class="payment-table"
              :showSorterTooltip="false"
              :scroll="{ x: 800}"
            >
              <template #bodyCell="{ column, text }">
                <template v-if="column.key === 'action' && text.children !== null">
                  <div @click="handleChangeExpand(text)">
                    <img
                      src="@/assets/images/arrow-down-thin.svg"
                      v-if="!expandColumns.includes(text.key)"
                    />
                    <img
                      src="@/assets/images/icon_up.svg"
                      v-if="expandColumns.includes(text.key)"
                    />
                  </div>
                </template>
              </template>
              <template #expandedRowRender="{ record }">
                <div
                  v-for="(item, indexItem) in record.usage_detail"
                  :key="indexItem"
                  class="content-payment"
                >
                  <div class="row mx-0 mg20">
                    <div class="col-md-6 pd8">{{ item.item_name }}</div>
                    <div class="col-md-6 pd8">{{ item.item_value }}</div>
                  </div>
                </div>
              </template>
              <template #date>
                <span>利用日</span>
                <img v-if="dirCostIncurredDate === SORT_ASC" @click="handleSort('cost_incurred_date')" class="mrl8" src="@/assets/images/sort_asc.svg" />
                <img v-else-if="dirCostIncurredDate === SORT_DESC" @click="handleSort('cost_incurred_date')" class="mrl8" src="@/assets/images/sort_desc.svg"/>
                <img v-else @click="handleSort('cost_incurred_date')" class="mrl8" src="@/assets/images/sort.svg"/>
              </template>
              <template #name>
                <span>支払項目名</span>
                <img v-if="dirCodeName === SORT_ASC" @click="handleSort('code_name')" class="mrl8" src="@/assets/images/sort_asc.svg" />
                <img v-else-if="dirCodeName === SORT_DESC" @click="handleSort('code_name')" class="mrl8" src="@/assets/images/sort_desc.svg"/>
                <img v-else @click="handleSort('code_name')" class="mrl8" src="@/assets/images/sort.svg"/>
              </template>
              <template #paid>
                <span>支払金額（税込）</span>
                <img v-if="dirPriceWithTax === SORT_ASC" @click="handleSort('price_with_tax')" class="mrl8" src="@/assets/images/sort_asc.svg" />
                <img v-else-if="dirPriceWithTax === SORT_DESC" @click="handleSort('price_with_tax')" class="mrl8" src="@/assets/images/sort_desc.svg"/>
                <img v-else @click="handleSort('price_with_tax')" class="mrl8" src="@/assets/images/sort.svg"/>
              </template>
            </a-table>
            <div>
              <Pagination
                @currentPage="changePage" showPageBottom="true"
                :total="this.usageDetail?.total"
                :pageSize="this.usageDetail?.per_page"
                :page="this.usageDetail?.page"
                ref="paginationRef"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from '@/plugins/dayjs';
import Pagination from '@/components/UsageDetail/Pagination.vue';
import AppLoading from '@/components/Loading/AppLoading.vue';
import FileSave from "file-saver";
import {
  NOT_DETERMINED,
  DETERMINED,
  PER_PAGE_OPTIONS,
  SORT_ASC,
  SORT_DESC,
} from '@/constants/usage';
import {
  DATE_FORMAT_DASH,
  YEAR_MONTH_FORMAT,
  FORMAT_DATE,
  DATE_YEAR_MONTH,
  DATE_TIME_FORMAT,
  PAGE_DEFAULT,
  DEFAULT_DATE_FORMAT
} from '@/constants/common';
import { mapGetters } from 'vuex';

const data = [];
export default {
  name: 'UsageDetail',
  data() {
    const columns = [
      {
        title: 'No',
        dataIndex: 'no',
        key: 'no',
      },
      {
        dataIndex: 'cost_incurred_date',
        key: 'cost_incurred_date',
        slots: { title: 'date' },
      },
      {
        dataIndex: 'code_name',
        key: 'code_name',
        slots: { title: 'name' },
      },
      {
        dataIndex: 'price_with_tax',
        key: 'price_with_tax',
        className: 'column-money',
        slots: { title: 'paid' },
      },
      {
        title: '',
        key: 'action',
        scopedSlots: { customRender: 'action' },
      },
    ];
    return {
      monthSelected: this.$dayjs(),
      monthNow: +this.$dayjs().format('M') + 1,
      dayOfMonth: this.$dayjs().date(1).format(DATE_TIME_FORMAT) + '～' + this.$dayjs(this.monthSelected).endOf('month').format(DATE_TIME_FORMAT),
      data,
      price: 0,
      status: 1,
      isStatus: NOT_DETERMINED,
      columns,
      page: 1,
      perPage: 50,
      sort: '',
      dir: '',
      dirPriceWithTax: '',
      dirCodeName: '',
      dirCostIncurredDate: '',
      isLoading: true,
      expandColumns: [],
      nextMonth: this.$dayjs().add(1, 'month').endOf('month').format(DATE_TIME_FORMAT),
      isMonth: true,
      dayOfWeek: this.$dayjs(this.$dayjs().add(1, 'month').endOf('month')).format('ddd'),
      PER_PAGE_OPTIONS,
      SORT_DESC,
      SORT_ASC,
      offset: ((new Date()).getTimezoneOffset() * -1) / 60,
    };
  },
  components: {
    AppLoading,
  },
  computed: {
    ...mapGetters({
      usageDetail: 'usage-detail/dataUsage',
    }),
  },
  async created() {
    await this.getData();
    window.scrollTo(0, 0);
    this.isLoading = false;
  },
  watch: {
    usageDetail() {
      if (this.usageDetail && this.usageDetail.list && this.usageDetail.list.usage_history) {
        this.data = this.usageDetail.list.usage_history;
        this.data = this.data.map((item, index) => {
          item.key = this.perPage * (this.page - 1) + index + 1;
          item.price_with_tax += '円';
          item.code_name = item.code_m_s_t_name_cate_f0001[0]?.code_name;
          item.cost_incurred_date = item.cost_incurred_date ? this.$formatTime(item.cost_incurred_date, DEFAULT_DATE_FORMAT) : '';
          if (item.key < 10) {
            item.no = '0' + item.key;
          } else {
            item.no = item.key;
          }
          return item;
        });
        this.price = this.formatCash(this.usageDetail.list.price);
        this.page = this.usageDetail.page;
        if (this.isMonth) {
          this.checkDayOfWeek(this.$dayjs());
        }
      }
    },
  },
  methods: {
    async getData() {
      const payload = {
        calendar: this.$dayjs(this.monthSelected).format(DATE_YEAR_MONTH),
        limit: this.perPage,
        page: this.page,
        sort: this.sort,
        dir: this.dir,
        timezone: this.offset,
      };
      return this.$store.dispatch('usage-detail/getUsageDetail', payload);
    },
    onSelectMonth(date, dateString) {
      this.monthSelected = date;
      const month = this.$dayjs(date).format('M');
      if (month < 12) {
        this.monthNow = +month + 1;
      } else {
        this.monthNow = 1;
      }
      this.dayOfMonth = this.$dayjs(this.monthSelected).date(1).format(DATE_TIME_FORMAT) + '～' + this.$dayjs(this.monthSelected).endOf('month').format(DATE_TIME_FORMAT);
      const now = this.$dayjs().format(DATE_YEAR_MONTH);
      const dateSelect = this.monthSelected.format(DATE_YEAR_MONTH);
      if (dateSelect >= now) {
        this.isStatus = NOT_DETERMINED;
      } else {
        this.isStatus = DETERMINED;
      }
      this.checkDayOfWeek(date);
      this.page = PAGE_DEFAULT;
      this.$refs.paginationRef1.current = PAGE_DEFAULT;
      this.$refs.paginationRef.current = PAGE_DEFAULT;
      this.getData();
    },
    onChangeMonth(type) {
      if (type === 'next') {
        this.monthSelected = this.$dayjs(this.monthSelected).set(
          'month',
          this.$dayjs(this.monthSelected).month() + 1
        );
        const month = this.$dayjs(this.monthSelected).format('M');
        if (month < 12) {
          this.monthNow = +month + 1;
        } else {
          this.monthNow = 1;
        }
        this.dayOfMonth = this.$dayjs(this.monthSelected).date(1).format(DATE_TIME_FORMAT) + '～' + this.$dayjs(this.monthSelected).endOf('month').format(DATE_TIME_FORMAT);
        const now = this.$dayjs().format(DATE_YEAR_MONTH);
        const dateSelect = this.monthSelected.format(DATE_YEAR_MONTH);
        if (dateSelect >= now) {
          this.isStatus = NOT_DETERMINED;
        } else {
          this.isStatus = DETERMINED;
        }
        this.checkDayOfWeek(this.monthSelected);
        this.getData();
      } else {
        this.monthSelected = this.$dayjs(this.monthSelected).set(
          'month',
          this.$dayjs(this.monthSelected).month() - 1
        );
        const month = this.$dayjs(this.monthSelected).format('M');
        if (month < 12) {
          this.monthNow = +month + 1;
        } else {
          this.monthNow = 1;
        }
        const now = this.$dayjs().format(DATE_YEAR_MONTH);
        const dateSelect = this.monthSelected.format(DATE_YEAR_MONTH);
        if (dateSelect >= now) {
          this.isStatus = NOT_DETERMINED;
        } else {
          this.isStatus = DETERMINED;
        }
        this.dayOfMonth = this.$dayjs(this.monthSelected).date(1).format(DATE_TIME_FORMAT) + '～' + this.$dayjs(this.monthSelected).endOf('month').format(DATE_TIME_FORMAT);
        this.checkDayOfWeek(this.monthSelected);
        this.page = PAGE_DEFAULT;
        this.$refs.paginationRef1.current = PAGE_DEFAULT;
        this.$refs.paginationRef.current = PAGE_DEFAULT;
        this.price = 0;
        this.getData();
      }
    },
    handleChangeExpand(item) {
      if (!this.expandColumns.includes(item.key)) {
        this.expandColumns.push(item.key);
      } else {
        this.expandColumns = this.expandColumns.filter((el) => el !== item.key);
      }
    },
    changePage(page) {
      this.page = page;
      this.$refs.paginationRef1.current = page;
      this.$refs.paginationRef.current = page;
      this.getData();
    },
    handleChangePerPage(perPage) {
      this.perPage = perPage;
      this.page = 1;
      this.getData();
      this.$refs.paginationRef.current = this.page;
      this.$refs.paginationRef1.current = this.page;
    },
    handleSort(sort) {
      if (sort === 'cost_incurred_date') {
        this.dirCodeName = '';
        this.dirPriceWithTax = '';
        if (this.dirCostIncurredDate === '') {
          this.dirCostIncurredDate = SORT_ASC;
          this.sort = sort;
        } else if (this.dirCostIncurredDate === SORT_ASC) {
          this.dirCostIncurredDate = SORT_DESC;
          this.sort = sort;
        } else if (this.dirCostIncurredDate === SORT_DESC) {
          this.dirCostIncurredDate = '';
          this.sort = '';
        }
        this.dir = this.dirCostIncurredDate;
      } else if (sort === 'code_name') {
        this.dirCostIncurredDate = '';
        this.dirPriceWithTax = '';
        if (this.dirCodeName === '') {
          this.dirCodeName = SORT_ASC;
          this.sort = sort;
        } else if (this.dirCodeName === SORT_ASC) {
          this.dirCodeName = SORT_DESC;
          this.sort = sort;
        } else if (this.dirCodeName === SORT_DESC) {
          this.dirCodeName = '';
          this.sort = '';
        }
        this.dir = this.dirCodeName;
      } else if (sort === 'price_with_tax') {
        this.dirCostIncurredDate = '';
        this.dirCodeName = '';
        if (this.dirPriceWithTax === '') {
          this.dirPriceWithTax = SORT_ASC;
          this.sort = sort;
        } else if (this.dirPriceWithTax === SORT_ASC) {
          this.dirPriceWithTax = SORT_DESC;
          this.sort = sort;
        } else if (this.dirPriceWithTax === SORT_DESC) {
          this.dirPriceWithTax = '';
          this.sort = '';
        }
        this.dir = this.dirPriceWithTax;
      }
      this.getData();
    },
    handleExportCSV() {
      const nameFile = this.$dayjs(this.monthSelected).format(YEAR_MONTH_FORMAT) + 'の利用明細_' + this.$dayjs().format(FORMAT_DATE) + '.csv';
      const payload = {
        calendar: this.$dayjs(this.monthSelected).format(DATE_YEAR_MONTH),
        timezone: this.offset,
      };
      this.$store.dispatch('usage-detail/exportCSV', payload).then(res => {
        const blob = new Blob([res], { type: "application/csv" });
        FileSave.saveAs(blob, nameFile);
      });
    },
    handleExportPDF() {
      const nameFile = this.$dayjs(this.monthSelected).format(YEAR_MONTH_FORMAT) + 'の利用明細_' + this.$dayjs().format(FORMAT_DATE) + '.pdf';
      const payload = {
        calendar: this.$dayjs(this.monthSelected).format(DATE_YEAR_MONTH),
        sort: this.sort,
        dir: this.dir,
        timezone: this.offset,
      };
      this.$store.dispatch('usage-detail/exportPDF', payload).then(res => {
        const blob = new Blob([res], { type: "application/csv" });
        FileSave.saveAs(blob, nameFile);
      });
    },
    onChangeRouter() {
      this.$router.push({ name: 'Bank Account Info' });
    },
    formatCash(number) {
      return number + '円';
    },
    checkDayOfWeek(date) {
      const nextMonth = this.$dayjs(date).add(1, 'month').endOf('month').format(DATE_FORMAT_DASH);
      const dayOfWeek = this.$dayjs(nextMonth).format('ddd');
      this.nextMonth = this.$dayjs(nextMonth).format(DATE_TIME_FORMAT);
      this.dayOfWeek = dayOfWeek;
      this.isMonth = false;
    }
  },
};
</script>
